module.exports = __webpack_public_path__ + "media/images/ic_facebook-216bdc9f42116ca366e29ceca22cf17b.svg";